import { render, staticRenderFns } from "./PkgRiskForm.vue?vue&type=template&id=2a85348f&"
import script from "./PkgRiskForm.vue?vue&type=script&lang=js&"
export * from "./PkgRiskForm.vue?vue&type=script&lang=js&"
import style0 from "./PkgRiskForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PkgRiskForm.vue"
export default component.exports